import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const MessageWithAQuestion = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 16, width = 15, ...props }, ref) => {
    return (
      <>
        <svg
          ref={ref}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M6 6H14M6 10H12M12 15H11L6 18V15H4C3.20435 15 2.44129 14.6839 1.87868 14.1213C1.31607 13.5587 1 12.7957 1 12V4C1 3.20435 1.31607 2.44129 1.87868 1.87868C2.44129 1.31607 3.20435 1 4 1H16C16.7956 1 17.5587 1.31607 18.1213 1.87868C18.6839 2.44129 19 3.20435 19 4V8.5M17 19V19.01M17 16C17.4483 15.9986 17.8832 15.8468 18.235 15.569C18.5868 15.2911 18.8352 14.9033 18.9406 14.4675C19.0459 14.0318 19.0019 13.5733 18.8158 13.1655C18.6297 12.7576 18.3122 12.424 17.914 12.218C17.5162 12.0142 17.0611 11.951 16.6228 12.0387C16.1845 12.1264 15.7888 12.3598 15.5 12.701"
            stroke="#1677FF"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    );
  },
);
